import DOMPurify from "dompurify";

// Function to sanitize input
// function sanitizeInput(input: string | Node) {
//   return DOMPurify.sanitize(input);
// }

// Recursive sanitization function
const sanitizeData = (data: any): any => {
  if (typeof data === "string") {
    // Sanitize strings
    return DOMPurify.sanitize(data);
  }

  if (Array.isArray(data)) {
    // Recursively sanitize each array element
    return data.map(sanitizeData);
  }

  if (data && typeof data === "object") {
    // Recursively sanitize each property in the object
    const sanitizedObject: Record<string, any> = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        sanitizedObject[key] = sanitizeData(data[key]);
      }
    }
    return sanitizedObject;
  }

  // Return non-string, non-object, and non-array values as-is
  return data;
};

export default sanitizeData;

// Example usage with form input
// const handleInputChange = (e) => {
//   const sanitizedValue = sanitizeInput(e.target.value);
//   setInputValue(sanitizedValue); // Only store the purified value
// };
